import React from 'react';
import Promise from 'bluebird';
import { connect } from 'react-redux';
import { signup } from './actions';
import { apply as addPromo } from 'components/promo/actions';
import { trackNow } from 'shared/models/analytic';
import { getLoggedInUser } from 'shared/models/api';
import SignupForm from './signup';
import PostSignup from './postSignup';
import Text from 'components/ui/text';
import View from 'components/ui/view';
import LoadingSpinner from 'components/ui/loadingSpinner';

class SignupWithPromo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      promo: (props.promo || '').toUpperCase(),
      postSignup: null,
      loading: false
    };

    this.handlePromoChange = this.handlePromoChange.bind(this);
    this.tryAddPromo = this.tryAddPromo.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  handlePromoChange(event) {
    this.setState({ promo: event.target.value });
  }

  handleLogin() {
    this.setState({ loading: true });
    const didEnterPromo = !!this.state.promo;
    if (!didEnterPromo) {
      if (this.props.shopNow) this.props.shopNow();
      else window.location = '/';
      return Promise.resolve();
    }

    return getLoggedInUser().then(res => {
      const { user } = res;
      if (user && user.orders && user.orders.length > 0) {
        return this.showPostSignup('not-new-user');
      } else {
        return this.tryAddPromo();
      }
    });
  }

  tryAddPromo() {
    this.setState({ loading: true });
    const attemptedCode = this.state.promo;
    if (!attemptedCode) {
      return this.showPostSignup('welcome');
    }

    trackNow('Coupon Entered', {
      source: 'signup',
      coupon: attemptedCode
    });

    return this.props.addPromo(attemptedCode).then(() => {
      const error = this.props.userPromo.error;
      const addedCode = this.props.userPromo.codes[0];

      if (error) {
        this.trackPromoFailure(attemptedCode, error);
        return this.showPostSignup('promo-invalid');
      } else {
        this.trackPromoSuccess(addedCode);
        return this.showPostSignup('promo-success');
      }
    });
  }

  trackPromoSuccess(addedCode) {
    trackNow('Coupon Applied', {
      source: 'signup',
      coupon_id: addedCode.code,
      coupon_name: addedCode.desc,
      discount: addedCode.val
    });
  }

  trackPromoFailure(attemptedCode, errorMsg) {
    trackNow('Coupon Denied', {
      source: 'signup',
      coupon: attemptedCode,
      reason: errorMsg
    });
  }

  showPostSignup(state) {
    if (state === 'welcome' && this.props.reloadOnSignup) {
      window.location.reload();
      return;
    }
    this.setState({ postSignup: state, loading: false });
    if (this.props.onPostSignup) this.props.onPostSignup();
    return Promise.resolve();
  }

  render() {
    return this.state.postSignup ? (
      <PostSignup
        message={this.state.postSignup}
        promoCodes={this.props.userPromo.codes}
        shopNow={this.props.shopNow}
      />
    ) : (
      <div>
        {this.state.loading && (
          <div className="loading-spinner-container">
            <LoadingSpinner green />
          </div>
        )}
        <View padding="sm">
          <Text display tag="h1" size="xxl" weight="med" margin="none">
            Get Started
          </Text>
          <Text display tag="h2" size="sm" weight="bold" margin="none">
            Craft beer, wine, spirits &amp; mixers delivered.
          </Text>
        </View>
        <View padding="sm">
          <SignupForm
            hideMobile
            compact={this.props.compact}
            promo={this.state.promo}
            onPromoChange={promo => this.setState({ promo })}
            onSubmit={user => this.props.signup(user)}
            onSuccess={() => this.tryAddPromo()}
            onFBSignup={() => this.tryAddPromo()}
            onFBLogin={() => this.handleLogin()}
            loading={this.state.loading}
          />
        </View>
      </div>
    );
  }
}

export default connect(
  state => ({
    userPromo: state.promo,
    login: state.login
  }),
  {
    addPromo,
    signup
  }
)(SignupWithPromo);



// WEBPACK FOOTER //
// ./shared/components/login/signupWithPromo.js